import { defineComponent as _defineComponent } from 'vue'
import { IProductCostsDetails } from '@/modules/catalog/services/products';
import { useDashStore } from '@/modules/common/store/DashModule';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';
import { computed, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetSpreadDetails',
  props: {
  costs: {
    type: Object as PropType<IProductCostsDetails>,
    default: null
  }
},
  setup(__props) {



const theme = useDashStore();

const borderColor = computed(() =>
  theme.isDarkMode ? '#FFFFFFB2' : '#EBE7E6'
);

const backgroundColor = computed(() =>
  theme.isDarkMode ? '#FFFFFF1A' : '#FFFFFF33'
);

const spreadGradientColorStart = '#325580';
const spreadGradientColorMid = '#34639c';
const spreadGradientColorEnd = '#75b7e9';

return { __sfc: true,theme, borderColor, backgroundColor, spreadGradientColorStart, spreadGradientColorMid, spreadGradientColorEnd, NebraskaColors, BaseText, InitialAvatarIcon }
}

})